import * as types from './types';
import Api from '../lib/api';

export function registerAction(user) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.post('Auth/Register', user);
            return response;
        }
        catch(err){
            console.error(err);
            throw(err);
        }
    }
}

export function userLogin(user) {
    return async(dispatch, getState) => {
        try{
            let response = await Api.post('auth/login', user);
            dispatch(login(response.data));
            return response;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function login(user) {
    return {
        type: types.LOGIN_USER,
        user,
    }
}

export function userLogout() {
    return (dispatch, getState) => {
        dispatch(logout());
    }
}

function logout() {
    return {
        type: types.LOGOUT_USER,
        user: {}
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js